$(document).ready(function() {
    $('body').on('keypress keyup paste', '[data-trim-spaces="true"]', function(e) {
        var element = this;
        setTimeout(function() {
            var currentValue = $(element).val();
            if (currentValue.startsWith(' ')) {
                $(element).attr('title', 'Значение не может иметь пробелов до первого символа и после последнего символа').tooltip('show');
            } else {
                $(element).tooltip('dispose').removeAttr('title');
            }
        }, 0);
    });

    $('body').on('focusout', '[data-trim-spaces="true"]', function() {
        var currentValue = $(this).val();
        if (currentValue.startsWith(' ') || currentValue.endsWith(' ')) {
            $(this).val(currentValue.trim());
        }
        $(this).tooltip('dispose').removeAttr('title');
    });
});
